import { Spinner as UISpinner } from "@gluestack-ui/themed";
import { SpinnerProps } from "./types";

export const Spinner = (props: SpinnerProps) => {
  return <UISpinner color="$primary600" size="large" {...props} />;
};

export default Spinner;
